
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { Article } from '../../types/shared/Article';

import './NewsPressHero.css';
import FeaturedArticle from '../FeaturedArticle/FeaturedArticle';
import Newsfeed from '../Newsfeed/Newsfeed';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';

interface INewsPressHeroProps extends MappedComponentProperties {
    backgroundColor?: 'white' | 'blue-creditone' | 'light-blue' | 'purple' | 'grey-alabaster';

    // For Featured Article
    articlePath?: string;
    article?: Article;
    ctaText?: string;
    ctaLink?: string;
    ctaButton?: boolean;
    hideBottomBorder?: boolean;
    newsVariant: true;
    hideImage?: boolean;

    // For Newsfeed
    pressArticles?: Article[];
}

export const NewsPressHeroEditConfig = {
    emptyLabel: 'News Press Hero',
    isEmpty: (props: PropsWithChildren<INewsPressHeroProps>) => {
        return !props || !props.articlePath;
    }
};

const NewsPressHero = (props: PropsWithChildren<INewsPressHeroProps>): JSX.Element | null => {
    const newsFeedDate: { currentPageNumber?: number } = JSON.parse(
        PathUtils.getMetaPropertyValue('newsFeedData') || '{}',
    );

    if (typeof newsFeedDate.currentPageNumber === 'number' && newsFeedDate.currentPageNumber > 1) {
        return null;
    }

    return (
    <div className={`flex md:flex-col pb-10 md:items-center justify-center bg-${props.backgroundColor}`}>
        <div className='max-w-[564px] md:mx-4 mt-10'>
            <FeaturedArticle 
                {...props} 
                bgIsWhite={props.backgroundColor === 'white'} 
                isInEditor={false} 
                newsVariant={true} >
            </FeaturedArticle>
        </div>
            <Newsfeed 
                {...props} 
                isDarkMode={props.backgroundColor === 'purple' || props.backgroundColor === 'blue-creditone'} 
                isInEditor={false} 
                variant={'newsPressHero'} 
                articlesToShow={props.hideImage ? 2 : 3}>
            </Newsfeed>
    </div>
    );
};

export default NewsPressHero;
        